import { render, staticRenderFns } from "./donut.md?vue&type=template&id=03a37816&"
import script from "./donut.md?vue&type=script&lang=js&"
export * from "./donut.md?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/core/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03a37816')) {
      api.createRecord('03a37816', component.options)
    } else {
      api.reload('03a37816', component.options)
    }
    module.hot.accept("./donut.md?vue&type=template&id=03a37816&", function () {
      api.rerender('03a37816', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "website/views/more/pie/donut.md"
export default component.exports